/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useEffect, useState } from "react"
import ApprovedGroupsItem from "./ApprovedGroupsItem"
import {
  Stack,
  LinearProgress,
  Paper,
  InputBase,
  IconButton,
} from "@mui/material"
import api from "../../../../base/services/ResApi"
import { FetchErrorHandeling } from "../../../../base/errorHandeling/FetchErrorHandeling"
import Alerts from "../../../../base/errorHandeling/Alerts"
import { Buffer } from "buffer"
import SearchIcon from "@mui/icons-material/Search"

const ApprovedGroups = ({ updateData, setUpdateData, orgCode, refreshKey = 0 }) => {
  const [approvedData, setApprovedData] = useState([])
  const [approvedOrgData, setApprovedOrgData] = useState([])
  const [filterData, setfilterData] = useState([])
  const [isGrpUpdated, setIsGrpUpdated] = useState(false)

  const [apprLoading, setApprDataLoading] = useState(true)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  // get logo
  const [orgLogo, setOrgLogo] = useState()

  let apprvLogoConfig = {
    headers: {
      "Is-Pending": "false",
    },
    responseType: "arraybuffer",
  }

  

  let apprvConfig = {
    headers: {
      Action: "V_ALL_APPR_GRP",
      "Sort-Column": "grp_id",
      "Sort-Order": "asc",
      Filter: "F_ORG_CODE",
      Value: orgCode,
      "Is-Pagination": "false",
      "X-Additional-Info":true
    },
  }
  useEffect(() => {
    setApprDataLoading(true)
    orgCode &&
      api
        .get("/groups", apprvConfig)
        .then((res) => {
          setApprovedData(res.data?.dataList)
          setfilterData(res.data?.dataList)
          setApprDataLoading(false)
          setErrorMessages([])
          setIserror(false)
          setIsUnauhtError(false)
          setUpdateData(false)
        })
        .catch((error) => {
          setApprDataLoading(false)
          setUpdateData(false)
          FetchErrorHandeling(
            error,
            setIserror,
            setErrorMessages,
            setIserrorShow,
            setIsUnauhtError
          )
        })

    // organization
    // logo
    api
      .get("/organizations/logo/" + orgCode, apprvLogoConfig)
      .then((res) => {
        const convertimg = Buffer.from(res.data, "binary").toString("base64")
        setOrgLogo(convertimg)
      })
      .catch((error) => {
        console.log(error)
      })
    // info
    api
      .get("/organizations/" + orgCode)
      .then((res) => {
        setApprovedOrgData(res.data?.dataList)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [updateData, isUnauhtError, orgCode, refreshKey])

  useEffect(() => {
    if (iserror === true) {
      setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
      }, 10000)
    }
  }, [iserror])

  useEffect(() => {
    if (isSuccess === true) {
      setTimeout(() => {
        setIsSuccess(false)
        setSuccessMessages([])
      }, 3000)
    }
  }, [isSuccess])

  const searchFilter = (e) => {
    const searchVal = e.target.value
    const results = approvedData.filter((grpData) => {
      return grpData.groupName.toLowerCase().includes(searchVal.toLowerCase())
    })
    setfilterData(results)
  }

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <Paper
        component="form"
        sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "100%", maxWidth: 360, minHeight: 58, mb: 3 }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search Group"
          inputProps={{ "aria-label": "search group" }}
          onChange={searchFilter}
        />
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
        </IconButton>
      </Paper>
      <br />
      {orgCode && apprLoading ? (
        <div>
          <LinearProgress />
        </div>
      ) : (
        <Stack
          sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 360px), 1fr))", gap: 2.5, alignItems: "stretch" }}
        >
          {filterData.map((grpData, i) => {
            return (
              <ApprovedGroupsItem
                key={grpData?.groupId}
                grpData={grpData}
                setIsSuccess={setIsSuccess}
                setSuccessMessages={setSuccessMessages}
                setIserror={setIserror}
                setErrorMessages={setErrorMessages}
                setIsUnauhtError={setIsUnauhtError}
                setIserrorShow={setIserrorShow}
                orgLogo={orgLogo}
                approvedOrgData={approvedOrgData[0]}
                updateData={updateData}
                setUpdateData={setUpdateData}
              />
            )
          })}
        </Stack>
      )}
    </div>
  )
}
export default ApprovedGroups
